import es from "date-fns/locale/es";
import moment from "moment";
import React from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import { getWeekDays, ISO8601_week_no } from "../../backend/common";
registerLocale("es", es);

const WeeklyDatePicker = (props) => {
  const { date, changeDate } = props;
  var weekNumber = ISO8601_week_no(new Date(date));
  var format = `${weekNumber}º yyyy '(${moment(date)
    .startOf("isoWeek")
    .format("DD MMM")} - ${moment(date).endOf("isoWeek").format("DD MMM")})'`;
  return (
    <ReactDatePicker
      selected={date.toDate()}
      startDate={moment(date).startOf("isoWeek").toDate()}
      endDate={moment(date).endOf("isoWeek").toDate()}
      onChange={(value) => changeDate(moment(value).startOf("isoWeek"))}
      locale="es"
      dateFormat={format}
      highlightDates={getWeekDays(date)}
      placeholderText="Fecha"
      dropdownMode="select"
      showWeekNumbers
      formatWeekNumber={(date) => {
        return ISO8601_week_no(new Date(date));
      }}
      showYearDropdown
      className="new-date-picker w-border"
      // Disable from today and beyond
      maxDate={moment().endOf("isoWeek").add(1, "week").toDate()}
    />
  );
};
export default WeeklyDatePicker;
